import Vue from "vue";
import actions from "./actions";
import {
  CREATE_CREDIT_CARD,
  FETCH_CREDIT_CARDS,
  FETCH_INVOICES,
  REMOVE_CREDIT_CARD,
  SET_PRIMARY_CARD,
  FETCH_PRIMARY_CARD,
  FETCH_SUBSCRIPTION,
  SAVE_PLAID_ACCOUNT,
  FETCH_SUBSCRIPTION_PLANS_INFO,
  FETCH_BANK_ACCOUNTS,
  FETCH_PAYMENT_METHODS
} from "./types";
import {
  loadingMutations,
  errorMutations,
  resetErrorsAndLoading,
  getter,
  metadataSetter
} from "@/store/utils";

import { paginationFilterSortGetters } from "@/store/common/getters";
import { sortSearchPaginateMutationsNewFormat } from "@/store/common/mutations";
import { setter } from "@/store/utils";
import { paginationFilterSortInitialObject } from "@/store/constants";

const state = {
  isLoading: false,
  errors: null,
  creditCards: [],
  subscriptions: [],
  bankAccounts: [],
  invoices: [],
  primaryCard: {},
  subscription: null,
  subscriptionPlansList: [],

  // loader status for payment method removing
  isPaymentSourceRemoving: false,
  removingId: null,
  ...paginationFilterSortInitialObject
};

const getters = {
  cards: getter("creditCards"),
  activeCard: state => state.creditCards[0],
  activeBankAccount: state => state.bankAccounts[0],
  primaryCardId: state => state.primaryCard,
  paymentMethods: state => {
    const paymentMethods = [...state.creditCards, ...state.bankAccounts];

    const idx = paymentMethods.findIndex(
      item => item.id === state.primaryCardId
    );

    const primaryAccount = paymentMethods.splice(idx, 1);

    return [...primaryAccount, ...paymentMethods];
  },
  invoices: getter("invoices"),
  isLoading: getter("isLoading"),
  bankAccounts: getter("bankAccounts"),
  isPaymentSourceRemoving: getter("isPaymentSourceRemoving"),
  removingId: getter("removingId"),
  subscriptionPlansList: getter("subscriptionPlansList"),
  primaryCard: getter("primaryCard"),
  cardsList: getter("creditCards"),
  ...paginationFilterSortGetters
};

const mutations = {
  [FETCH_SUBSCRIPTION.success](state, { payload }) {
    Vue.set(state, "subscription", payload);
    resetErrorsAndLoading(state);
  },

  [FETCH_PRIMARY_CARD.success](state, { payload }) {
    Vue.set(state, "primaryCard", payload);
    resetErrorsAndLoading(state);
  },

  [FETCH_CREDIT_CARDS.success](state, { payload }) {
    Vue.set(state, "creditCards", payload);
    resetErrorsAndLoading(state);
  },

  [FETCH_BANK_ACCOUNTS.success](state, { payload }) {
    Vue.set(state, "bankAccounts", payload);
    resetErrorsAndLoading(state);
  },

  [FETCH_SUBSCRIPTION_PLANS_INFO.success](state, { payload }) {
    setter("subscriptionPlansList", payload)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_PAYMENT_METHODS.success](state, { payload }) {
    const { creditCards, bankAccounts } = payload;
    setter("creditCards", creditCards)(state);
    setter("bankAccounts", bankAccounts)(state);
    resetErrorsAndLoading(state);
  },

  [SET_PRIMARY_CARD.request](state) {},
  [SET_PRIMARY_CARD.error](state) {},

  [CREATE_CREDIT_CARD.success](state, { payload }) {
    const updCardsList = [...state.creditCards];
    updCardsList.unshift(payload);
    setter("creditCards", updCardsList)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_INVOICES.success](state, { payload }) {
    Vue.set(state, "invoices", payload.items);
    metadataSetter(payload, state);
    resetErrorsAndLoading(state);
  },

  [REMOVE_CREDIT_CARD.request](state, { payload }) {
    setter("removingId", payload)(state);
    setter("isPaymentSourceRemoving", true)(state);
  },

  [REMOVE_CREDIT_CARD.error](state) {
    setter("isPaymentSourceRemoving", false)(state);
  },

  [REMOVE_CREDIT_CARD.success](state, { payload }) {
    const withoutCard = state.creditCards.filter(card => card.id !== payload);
    setter("creditCards", withoutCard)(state);
    setter("isPaymentSourceRemoving", false)(state);
    setter("removingId", null)(state);
    resetErrorsAndLoading(state);
  },

  [SET_PRIMARY_CARD.success](state, { payload }) {
    setter("primaryCard", payload);
    resetErrorsAndLoading(state);
  },

  [SAVE_PLAID_ACCOUNT.success](state, { payload }) {
    setter("bankAccounts", payload);
    resetErrorsAndLoading(state);
  },

  ...loadingMutations([
    CREATE_CREDIT_CARD.request,
    FETCH_CREDIT_CARDS.request,
    FETCH_INVOICES.request,
    FETCH_PRIMARY_CARD.request,
    SAVE_PLAID_ACCOUNT.request,
    FETCH_SUBSCRIPTION_PLANS_INFO.request,
    FETCH_BANK_ACCOUNTS.request,
    FETCH_PAYMENT_METHODS.request
  ]),
  ...errorMutations([
    CREATE_CREDIT_CARD.error,
    FETCH_CREDIT_CARDS.error,
    FETCH_INVOICES.error,
    FETCH_PRIMARY_CARD.error,
    SAVE_PLAID_ACCOUNT.error,
    FETCH_SUBSCRIPTION_PLANS_INFO.error,
    FETCH_BANK_ACCOUNTS.error,
    FETCH_PAYMENT_METHODS.error
  ]),

  ...sortSearchPaginateMutationsNewFormat
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
